import { render, staticRenderFns } from "./productoPromocion.vue?vue&type=template&id=01ffca58&scoped=true&"
import script from "./productoPromocion.vue?vue&type=script&lang=js&"
export * from "./productoPromocion.vue?vue&type=script&lang=js&"
import style0 from "./productoPromocion.vue?vue&type=style&index=0&id=01ffca58&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffca58",
  null
  
)

export default component.exports